/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Autopay from './Autopay/index'
import InsuranceClaims from './InsuranceClaims/index'
import No from './No/index'
import React from 'react'
import Statements from './Statements/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Financial/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let tabSelectedTabValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.tab',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: tabSelectedTabValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Statements'}>
<Statements
  viewPath={`${viewPath}/Statements`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Autopay'}>
<Autopay
  viewPath={`${viewPath}/Autopay`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'InsuranceClaims'}>
<InsuranceClaims
  viewPath={`${viewPath}/InsuranceClaims`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}